/**
 * Make footer element always stick to the bottom of the page
*/

import EventBus from '../event-bus.js'
import jQuery from 'jquery'

const StickyFooter = {
    
    run() {

        const
            footer = jQuery('footer').last(),
            body = jQuery('body'),
            setBodyPadding = () => {
            body.css({
                minHeight:      jQuery(window).height(),
                paddingBottom:  footer.outerHeight()
            })
        }

        body.css('position', 'relative')
        jQuery(window).resize(setBodyPadding)
        setBodyPadding()
        
        footer.addClass('sticky-applied').css({
            bottom: 0,
            left: 0,
            position: 'absolute',
            width: '100%'
        })
        
    }

}

EventBus.subscribe('run-modules', StickyFooter.run)

export default StickyFooter